import type {AppConfig} from '../../../types'
import {getCoordinates} from './get-coordinates'

export function toDefaultRoute(config: AppConfig) {
  const routeFromConfig = config.initialProps?.bduiInitialRequest?.state.route

  return routeFromConfig?.source
    ? Object.keys(routeFromConfig).flatMap(key => {
        // если адрес не установлен, не передаем точку
        return routeFromConfig[key]?.address?.coordinates
          ? {
              type: key === 'source' || key === 'return' ? key : 'destination',
              coordinates: routeFromConfig[key].address.coordinates,
              uri: routeFromConfig[key].address.uri,
            }
          : []
      })
    : [
        {
          coordinates: getCoordinates('source', config),
          type: 'source',
        },
      ]
}
